const MULTILIKES_OPTIMISTIC_DISABLE_MS = 500;

function disableTemporarily(element, duration = MULTILIKES_OPTIMISTIC_DISABLE_MS) {
  if (!element) return;
  element.disabled = true;
  if (element._multilikesDisableTimer) {
    clearTimeout(element._multilikesDisableTimer);
  }
  element._multilikesDisableTimer = setTimeout(() => {
    element.disabled = false;
    element._multilikesDisableTimer = null;
  }, duration);
}

function parseFavoriteCountValue(value) {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : Math.max(0, parsed);
}

function adjustFavoriteCountValue(currentCount, wasFavorited, isFavorited) {
  const parsed = parseFavoriteCountValue(currentCount);
  if (parsed === null || wasFavorited === isFavorited) {
    return parsed;
  }
  return isFavorited ? parsed + 1 : Math.max(0, parsed - 1);
}

// 商品お気に入りボタン
class CustomProductWishlistButton {
  constructor(button) {
    this.button = button;
    this.productId = button.dataset.productId || '';
    this.variantId = button.dataset.variantId || '';
    this.customerId = window.multilikesProductConfig?.customerId || button.dataset.customerId || null;
    this.isInWishlist = button.dataset.isInWishlist === 'true';
    this.defaultUrl = window.multilikesProductConfig.defaultUrl;
    this.texts = window.multilikesProductConfig?.texts || {};
    this.favoriteCount = parseFavoriteCountValue(button.dataset.favoriteCount) ?? 0;
    this.requestSeq = 0;
    this.pendingRequestCount = 0;
    this.finalSyncTimer = null;

    if (this.customerId) {
      this.button.addEventListener('click', () => this.toggleWishlist());
    } else {
      this.button.addEventListener('click', () => this.redirectToLogin());
      // this.button.textContent = this.texts.addToFavorites || 'お気に入りに追加';
      // if(this.button.dataset.favoriteCount) {
      //   this.button.textContent += ` (${this.button.dataset.favoriteCount})`;
      // }
    }
  }

  updateButtonState(isInWishlist, favoriteCount) {
    if (typeof isInWishlist === 'boolean') {
      this.isInWishlist = isInWishlist;
    }

    this.button.dataset.isInWishlist = this.isInWishlist.toString();
    this.button.classList.toggle('is-active', this.isInWishlist);

    if (favoriteCount !== undefined && favoriteCount !== null) {
      if (typeof favoriteCount === 'number' && !Number.isNaN(favoriteCount)) {
        this.favoriteCount = favoriteCount;
      } else {
        this.favoriteCount = 0;
      }
    }

    // let buttonText = this.isInWishlist 
    //   ? (this.texts.removeFavorites || 'お気に入りから削除') 
    //   : (this.texts.addToFavorites || 'お気に入りに追加');

    // this.button.textContent = buttonText;

    // Button Wishlist Count
    const wishlistCountTextList = document.querySelectorAll(`[data-multilikes-product-count][data-product-id="${this.productId}"]`);
    if(wishlistCountTextList.length > 0) {
      wishlistCountTextList.forEach(wishlistCountText => {
        const template =
          this.texts.favoriteCount || wishlistCountText.textContent || '[[amount]]';
        wishlistCountText.textContent = template.replace('[[amount]]', String(this.favoriteCount));
        wishlistCountText.classList.remove('is-loading');
      });
    }
  }

  resolveFavoriteCount(data) {
    if (!data) {
      return null;
    }

    const favoriteCount = data.favoriteCount;
    if (typeof favoriteCount === 'number' && !Number.isNaN(favoriteCount)) {
      return favoriteCount;
    }

    const updatedCount = data.updatedCount;
    if (typeof updatedCount === 'number' && !Number.isNaN(updatedCount)) {
      return updatedCount;
    }

    return null;
  }

  nextRequestSeq() {
    this.requestSeq += 1;
    return this.requestSeq;
  }

  isLatestRequest(seq, productId = this.productId, variantId = this.variantId) {
    return seq === this.requestSeq &&
      productId === this.productId &&
      variantId === this.variantId;
  }

  invalidatePendingResponses() {
    this.requestSeq += 1;
  }

  scheduleFinalSync() {
    if (this.finalSyncTimer) {
      clearTimeout(this.finalSyncTimer);
    }
    this.finalSyncTimer = setTimeout(() => {
      this.finalSyncTimer = null;
      if (this.pendingRequestCount === 0 && this.customerId) {
        CustomProductWishlistButton.updateButtonStatus(this, { includeFavoriteCount: true });
      }
    }, 0);
  }

  buildOptimisticWishlist(productId, variantId, isInWishlist) {
    const triggers = document.querySelectorAll(
      `[data-wishlist-variants-trigger][data-product-id="${productId}"]`
    );
    const currentIds = new Set();
    triggers.forEach(trigger => {
      const variantIds = (trigger.dataset.productVariants || '')
        .split(',')
        .map(v => v.trim())
        .filter(Boolean);
      const isActive = trigger.classList.contains('is-active');
      if (isActive) {
        variantIds.forEach(id => currentIds.add(id));
      }
    });
    const targetId = String(variantId);
    if (isInWishlist) {
      currentIds.add(targetId);
    } else {
      currentIds.delete(targetId);
    }
    return Array.from(currentIds).map(id => ({ id }));
  }

  async toggleWishlist() {
    const previousState = this.isInWishlist;
    const previousCount = this.favoriteCount;
    const nextState = !previousState;
    const action = nextState ? 'add' : 'remove';
    const requestProductId = this.productId;
    const requestVariantId = this.variantId;
    const seq = this.nextRequestSeq();
    this.pendingRequestCount += 1;

    this.updateButtonState(
      nextState,
      adjustFavoriteCountValue(previousCount, previousState, nextState)
    );
    CustomProductWishlistButton.updateGridTriggerState(
      requestProductId,
      this.buildOptimisticWishlist(requestProductId, requestVariantId, nextState)
    );
    disableTemporarily(this.button);

    try {
      const response = await fetch(this.defaultUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: new URLSearchParams({
          'customer_id': this.customerId,
          'product_id': requestProductId,
          'variant_id': requestVariantId,
          'target_type': 'product',
          'action': action
        })
      });

      const data = await response.json();

      if (!this.isLatestRequest(seq, requestProductId, requestVariantId)) {
        if (!response.ok) {
          console.error('Stale wishlist update failed:', data);
        }
        return;
      }

      if (response.ok) {
        const payload = data?.data || {};

        const favoriteCount = this.resolveFavoriteCount(payload);
        const resolvedState = typeof payload.isInWishlist === 'boolean'
          ? payload.isInWishlist
          : nextState;
        this.updateButtonState(resolvedState, favoriteCount);
        if (Array.isArray(payload.wishlist)) {
          CustomProductWishlistButton.updateGridTriggerState(requestProductId, payload.wishlist);
        }
      } else {
        throw new Error(data?.error || 'Failed to update wishlist');
      }
    } catch (error) {
      if (this.isLatestRequest(seq, requestProductId, requestVariantId)) {
        this.updateButtonState(previousState, previousCount);
        CustomProductWishlistButton.updateGridTriggerState(
          requestProductId,
          this.buildOptimisticWishlist(requestProductId, requestVariantId, previousState)
        );
        alert(this.texts.error || 'お気に入りの更新に失敗しました');
      } else {
        console.error('Stale wishlist update failed:', error);
      }
    } finally {
      this.pendingRequestCount = Math.max(0, this.pendingRequestCount - 1);
      if (this.pendingRequestCount === 0) {
        this.scheduleFinalSync();
      }
    }
  }

  redirectToLogin() {
    window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.href);
  }

  /**
   * 静的メソッド：商品お気に入りボタンの初期化
   * @param {HTMLElement} button - 商品お気に入りボタン要素
   * @returns {CustomProductWishlistButton|null} - 作成されたインスタンス
   */
  static async init(button) {
    if (!button) {
      console.error('Button element is required');
      return null;
    }
    
    const variantId = button.dataset.variantId;
    
    if (!variantId) {
      console.error('Variant ID not found in button');
      return null;
    }

    // 既に初期化済みの場合はスキップ
    if (button.dataset.initialized === 'true') {
      return button._wishlistButtonInstance;
    }

    button.dataset.initialized = 'true';
    
    // 新しいインスタンスを作成
    const instance = new CustomProductWishlistButton(button);
    button._wishlistButtonInstance = instance;
    
    return instance;
  }

  /**
   * 静的メソッド：すべての商品お気に入りボタンを初期化
   */
  static async initAllButtons() {
    const wishlistButtons = document.querySelectorAll('[data-custom-multilikes-product-button]');
    const initPromises = Array.from(wishlistButtons).map(button => 
      CustomProductWishlistButton.init(button)
    );
    await Promise.all(initPromises);
    CustomProductWishlistButton.bindVariantChangeListener();

    wishlistButtons.forEach(button => {
      const instance = button._wishlistButtonInstance;
      if (!instance) {
        return;
      }
      CustomProductWishlistButton.updateButtonStatus(instance, { includeFavoriteCount: true });
    });
  }

  /**
   * 静的メソッド：対象の商品お気に入りボタンを取得
   */
  static findWishlistButton() {
    return document.querySelector('[data-custom-multilikes-product-button]');
  }

  /**
   * 静的メソッド：バリアント変更イベントを監視
   */
  static bindVariantChangeListener() {
    if (CustomProductWishlistButton.variantChangeListenerBound) {
      return;
    }

    document.addEventListener('variant:change', async ({ detail }) => {
      if (!detail?.variant) {
        return;
      }

      const wishlistButton = CustomProductWishlistButton.findWishlistButton();
      const instance = wishlistButton?._wishlistButtonInstance;
      if (!instance) {
        return;
      }

      try {
        await CustomProductWishlistButton.updateButtonData(detail.variant, {
          includeFavoriteCount: !instance.customerId,
        });
      } catch (error) {
        console.error('Error updating wishlist button data:', error);
      }
    });

    CustomProductWishlistButton.variantChangeListenerBound = true;
  }

  /**
   * 静的メソッド：ボタンのdata属性を更新
   */
  static async updateButtonData(variant, options = {}) {
    try {
      const button = CustomProductWishlistButton.findWishlistButton();
      const newVariantId = variant?.id;
      if (!button || !newVariantId) {
        return;
      }

      const newProductId =
        variant?.product_id ||
        button.dataset.productId;
      
      if (newProductId) {
        // data属性を更新
        button.dataset.productId = newProductId;
        button.dataset.variantId = newVariantId;

        // インスタンスのプロパティも更新
        if (button._wishlistButtonInstance) {
          button._wishlistButtonInstance.invalidatePendingResponses();
          button._wishlistButtonInstance.productId = newProductId;
          button._wishlistButtonInstance.variantId = newVariantId;

          // 新しいvariantIdのお気に入りステータスを確認してボタンステータスを更新
          await CustomProductWishlistButton.updateButtonStatus(button._wishlistButtonInstance, options);
        }
      }
    } catch (error) {
      console.error('Error updating button data:', error);
    }
  }

  /**
   * 静的メソッド：ボタンのお気に入りステータスを更新
   */
  static async updateButtonStatus(instance, options = {}) {
    const requestProductId = instance.productId;
    const requestVariantId = instance.variantId;
    const seq = instance.nextRequestSeq();

    try {
      // ローディング状態を設定（クリックは引き続き許可）
      instance.button.classList.add('is-loading');

      const params = new URLSearchParams({
        'target_type': 'product',
        'product_id': requestProductId,
        'variant_id': requestVariantId,
      });
      if (instance.customerId) {
        params.set('customer_id', instance.customerId);
      }
      if (options.includeFavoriteCount === false) {
        params.set('skip_favorite_count', 'true');
      }

      const response = await fetch(`${instance.defaultUrl}?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        const data = await response.json();

        if (!instance.isLatestRequest(seq, requestProductId, requestVariantId)) {
          return;
        }

        if (data.data && data.data.isInWishlist !== undefined) {
          const favoriteCount = instance.resolveFavoriteCount(data.data);
          instance.updateButtonState(data.data.isInWishlist, favoriteCount);
          if (Array.isArray(data.data.wishlist)) {
            CustomProductWishlistButton.updateGridTriggerState(requestProductId, data.data.wishlist);
          }
        }
      } else {
        console.error('Failed to check wishlist status for variant:', requestVariantId);
      }
    } catch (error) {
      console.error('Error checking wishlist status for variant:', error);
    } finally {
      // ローディング状態を解除
      instance.button.classList.remove('is-loading');
    }
  }

  /**
   * 静的メソッド：グリッドアイテム上のお気に入りトリガーボタンの状態を更新
   * モーダル内で variant のお気に入りをトグルした後に、グリッドのトリガーの is-active を同期する
   * @param {string|number} productId - 商品ID
   * @param {Array<{id: string|number}>} wishlist - お気に入り済み variant ID の配列
   */
  static updateGridTriggerState(productId, wishlist) {
    const triggers = document.querySelectorAll(
      `[data-wishlist-variants-trigger][data-product-id="${productId}"]`
    );
    if (triggers.length === 0) return;

    const wishlistIds = new Set((wishlist || []).map(item => String(item.id)));

    triggers.forEach(trigger => {
      const variantIds = (trigger.dataset.productVariants || '')
        .split(',')
        .map(v => v.trim())
        .filter(Boolean);
      const hasAnyInWishlist = variantIds.some(id => wishlistIds.has(id));
      trigger.classList.toggle('is-active', hasAnyInWishlist);
    });
  }
}

// ブランドお気に入りボタン
class CustomProductBrandWishlistButton {
  constructor(button) {
    this.button = button;
    this.vendor = this.parseVendor(button.dataset.vendor);
    this.customerId = window.multilikesProductConfig?.customerId || button.dataset.customerId || null;
    this.defaultUrl = window.multilikesProductConfig?.defaultUrl;
    this.texts = window.multilikesProductConfig?.texts || {};
    this.metaobjectId = button.dataset.metaobjectId || null;
    this.directMode = Boolean(this.metaobjectId);
    this.loginUrl = button.dataset.loginUrl || '';
    this.isInWishlist = button.dataset.isInWishlist === 'true';
    this.favoriteCount = 0;
    this.showFavoritesCount = button.dataset.showFavoritesCount === 'true';
    this.favoriteCountText = button.dataset.favoriteCountText || '([[amount]])';
    this.requestSeq = 0;
    this.pendingRequestCount = 0;
    this.finalSyncTimer = null;
  }

  parseVendor(rawVendor) {
    if (!rawVendor) return '';
    try {
      const parsed = JSON.parse(rawVendor);
      if (typeof parsed === 'string') {
        return parsed;
      }
    } catch (_) {
      // noop
    }
    return rawVendor;
  }

  updateButtonState(isInWishlist, favoriteCount) {
    if (typeof isInWishlist === 'boolean') {
      this.isInWishlist = isInWishlist;
    }

    if (favoriteCount !== undefined && favoriteCount !== null) {
      if (typeof favoriteCount === 'number' && !Number.isNaN(favoriteCount)) {
        this.favoriteCount = favoriteCount;
      } else {
        this.favoriteCount = this.showFavoritesCount ? 0 : this.favoriteCount;
      }
    } else if (this.showFavoritesCount) {
      this.favoriteCount = 0;
    }

    this.button.dataset.isInWishlist = this.isInWishlist.toString();
    if (this.metaobjectId) {
      this.button.dataset.metaobjectId = this.metaobjectId;
    }
    this.button.classList.toggle('is-active', this.isInWishlist);

    // const buttonText = this.isInWishlist
    //   ? (this.texts.removeFromBrandFavoritesText || 'お気に入りから削除')
    //   : (this.texts.addToBrandFavoritesText || 'お気に入りに追加');
    if (this.showFavoritesCount) {
      const count = Number.isFinite(this.favoriteCount) ? this.favoriteCount : 0;
      const template = this.favoriteCountText || '([[amount]])';
      // this.button.textContent = `${buttonText} ${template.replace('[[amount]]', String(count))}`;
    } else {
      // this.button.textContent = buttonText;
    }

    this.button.setAttribute('aria-pressed', this.isInWishlist.toString());
    const ariaLabel = this.isInWishlist
      ? this.button.dataset.labelOn
      : this.button.dataset.labelOff;
    if (ariaLabel) {
      this.button.setAttribute('aria-label', ariaLabel);
    }

    this.button.removeAttribute('hidden');
    if(this.button.closest('.c-product-wishlist-brand-btn__wrapper[hidden]')) {
      this.button.closest('.c-product-wishlist-brand-btn__wrapper').removeAttribute('hidden');
    }
  }

  resolveFavoriteCount(data) {
    if (!data) {
      return null;
    }
    const favoriteCount = data.favoriteCount;
    if (typeof favoriteCount === 'number' && !Number.isNaN(favoriteCount)) {
      return favoriteCount;
    }
    const updatedCount = data.updatedCount;
    if (typeof updatedCount === 'number' && !Number.isNaN(updatedCount)) {
      return updatedCount;
    }
    return null;
  }

  nextRequestSeq() {
    this.requestSeq += 1;
    return this.requestSeq;
  }

  isLatestRequest(seq, metaobjectId = this.metaobjectId) {
    return seq === this.requestSeq && metaobjectId === this.metaobjectId;
  }

  scheduleFinalSync() {
    if (this.directMode) {
      return;
    }
    if (this.finalSyncTimer) {
      clearTimeout(this.finalSyncTimer);
    }
    this.finalSyncTimer = setTimeout(() => {
      this.finalSyncTimer = null;
      if (this.pendingRequestCount === 0 && this.metaobjectId) {
        this.fetchBrandMetaobject({ silent: true });
      }
    }, 0);
  }

  async toggleWishlist() {
    if (!this.metaobjectId) {
      return;
    }
    const previousState = this.isInWishlist;
    const previousCount = this.favoriteCount;
    const nextState = !previousState;
    const action = nextState ? 'add' : 'remove';
    const requestMetaobjectId = this.metaobjectId;
    const seq = this.nextRequestSeq();
    this.pendingRequestCount += 1;

    this.updateButtonState(
      nextState,
      adjustFavoriteCountValue(previousCount, previousState, nextState)
    );
    disableTemporarily(this.button);
    this.button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(this.defaultUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: new URLSearchParams({
          'customer_id': this.customerId,
          'metaobject_type': 'multilikes_brand',
          'metaobject_id': requestMetaobjectId,
          'target_type': 'metaobject',
          'action': action
        })
      });

      const data = await response.json();

      if (!this.isLatestRequest(seq, requestMetaobjectId)) {
        if (!response.ok) {
          console.error('Stale brand wishlist update failed:', data);
        }
        return;
      }

      if (response.ok) {
        const payload = data?.data || {};

        const favoriteCount = this.resolveFavoriteCount(payload);
        const isInWishlist = typeof payload.isInWishlist === 'boolean'
          ? payload.isInWishlist
          : nextState;
        this.updateButtonState(isInWishlist, favoriteCount);
      } else {
        throw new Error(data?.error || 'Failed to update brand wishlist');
      }
    } catch (error) {
      if (this.isLatestRequest(seq, requestMetaobjectId)) {
        this.updateButtonState(previousState, previousCount);
        alert(this.texts.error || 'お気に入りの更新に失敗しました');
      } else {
        console.error('Stale brand wishlist update failed:', error);
      }
    } finally {
      this.pendingRequestCount = Math.max(0, this.pendingRequestCount - 1);
      if (this.pendingRequestCount === 0) {
        this.button.removeAttribute('aria-busy');
        this.scheduleFinalSync();
      }
    }
  }

  redirectToLogin() {
    const returnUrl = window.location.pathname + window.location.search + window.location.hash;
    const loginUrl = this.loginUrl || '/account/login';
    window.location.href = loginUrl + '?return_url=' + encodeURIComponent(returnUrl);
  }

  async fetchBrandMetaobject(options = {}) {
    if (!this.vendor) {
      this.disableButton('ブランド情報がありません');
      return;
    }

    const seq = this.nextRequestSeq();
    const requestMetaobjectId = this.metaobjectId;

    try {
      if (!options.silent && !this.metaobjectId) {
        this.button.disabled = true;
      }
      this.button.classList.add('is-loading');

      const params = new URLSearchParams({
        'target_type': 'get_product_brand',
        'vendor': this.vendor,
        'limit': '5',
      });

      if (this.customerId) {
        params.set('customer_id', this.customerId);
      }

      const response = await fetch(`${this.defaultUrl}?${params.toString()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        if (!this.isLatestRequest(seq, requestMetaobjectId)) {
          return;
        }
        console.error('Failed to fetch brand metaobjects:', response.status);
        if (!options.silent) {
          this.disableButton(this.texts.error || 'ブランド情報の取得に失敗しました');
        }
        return;
      }

      const data = await response.json();

      if (!this.isLatestRequest(seq, requestMetaobjectId)) {
        return;
      }

      const payload = data?.data || {};

      const primaryBrand = payload.primaryBrand || (Array.isArray(payload.brands) ? payload.brands[0] : null);

      if (!primaryBrand?.id) {
        this.disableButton(this.texts.empty || 'ブランドが見つかりません');
        return;
      }

      this.metaobjectId = primaryBrand.id;
      const favoriteCount = this.resolveFavoriteCount(primaryBrand);
      this.updateButtonState(Boolean(primaryBrand.isInWishlist), favoriteCount);
    } catch (error) {
      console.error('Error fetching brand metaobjects:', error);
      if (!options.silent) {
        this.disableButton(this.texts.error || 'ブランド情報の取得に失敗しました');
      }
    } finally {
      if (this.metaobjectId) {
        this.button.disabled = false;
      }
      this.button.classList.remove('is-loading');
    }
  }

  disableButton(message) {
    if (message) {
      // this.button.textContent = message;
    }
    this.button.disabled = true;
    this.button.classList.remove('is-loading');
  }

  async bootstrap() {
    if (this.customerId) {
      this.button.addEventListener('click', () => this.toggleWishlist());
    } else {
      this.button.addEventListener('click', () => this.redirectToLogin());
      // this.button.textContent = this.texts.addToBrandFavoritesText || 'お気に入りに追加';
    }

    if (this.directMode) {
      this.updateButtonState(this.isInWishlist);
      return;
    }

    await this.fetchBrandMetaobject();
  }

  static async init(button) {
    if (!button) {
      console.error('Brand button element is required');
      return null;
    }

    if (button.dataset.initialized === 'true') {
      return button._brandWishlistButtonInstance;
    }

    button.dataset.initialized = 'true';
    const instance = new CustomProductBrandWishlistButton(button);
    button._brandWishlistButtonInstance = instance;
    await instance.bootstrap();
    return instance;
  }

  static async initAllButtons() {
    const brandButtons = document.querySelectorAll('[data-custom-multilikes-product-brand-button]');
    const initPromises = Array.from(brandButtons).map(button =>
      CustomProductBrandWishlistButton.init(button)
    );
    await Promise.all(initPromises);
  }
}

// =====================================================
// グリッドアイテム用: お気に入りトリガーボタン + 動的モーダル
// =====================================================
function initCustomProductWishlistGridTriggers(root = document) {
  const triggers = root.querySelectorAll(
    '[data-wishlist-variants-trigger]:not([data-wl-trigger-initialized])'
  );
  triggers.forEach((trigger) => {
    trigger.dataset.wlTriggerInitialized = 'true';
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openWishlistVariantsModal(trigger);
    });
  });
}

async function openWishlistVariantsModal(trigger) {
  const productId = trigger.dataset.productId;
  const productHandle = trigger.dataset.productHandle;
  const productTitle = trigger.dataset.productTitle;
  const modalId = `WishlistVariantsModal-${productId}`;
  const modalName = `wishlist-variants-${productId}`;

  let modal = document.getElementById(modalId);
  let modalInstance = modal && modal._themeModalInstance;

  if (!modal || !modalInstance) {
    trigger.classList.add('is-loading');
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      if (!response.ok) {
        throw new Error('Failed to fetch product JSON');
      }
      const productData = await response.json();

      modal = buildWishlistVariantsModal(modalId, productTitle, productData);
      document.body.appendChild(modal);

      modalInstance = new theme.Modals(modalId, modalName);
      modal._themeModalInstance = modalInstance;

      const buttons = modal.querySelectorAll('[data-custom-multilikes-product-button]');
      await Promise.all(
        Array.from(buttons).map(async (btn) => {
          const instance = await CustomProductWishlistButton.init(btn);
          if (instance) {
            await CustomProductWishlistButton.updateButtonStatus(instance, { includeFavoriteCount: true });
          }
        })
      );
    } catch (error) {
      console.error('Failed to open wishlist variants modal:', error);
      return;
    } finally {
      trigger.classList.remove('is-loading');
    }
  }

  modalInstance.open();
}

function buildWishlistVariantsModal(modalId, productTitle, productData) {
  const escapeHtml = (str) => {
    const div = document.createElement('div');
    div.textContent = String(str == null ? '' : str);
    return div.innerHTML;
  };
  const heartSvg = `
    <svg class="icon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3 c1.74 0 3.41.81 4.5 2.09 C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5 c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
            fill="var(--icon-fill)" stroke="var(--icon-stroke)" stroke-width="1.5" stroke-linejoin="round"/>
    </svg>`;

  const itemsHtml = (productData.variants || []).map((variant) => {
    const imgSrc = variant.featured_image && variant.featured_image.src
      ? variant.featured_image.src
      : (productData.featured_image || '');
    return `
      <li class="c-wishlist-variants-modal__item">
        <div class="c-wishlist-variants-modal__image">
          ${imgSrc ? `<img src="${escapeHtml(imgSrc)}" alt="${escapeHtml(variant.title)}" loading="lazy" width="64" height="64">` : ''}
        </div>
        <span class="c-wishlist-variants-modal__name">${escapeHtml(variant.title)}</span>
        <div class="c-product-wishlist-btn__wrapper">
          <button class="c-product-wishlist-btn" type="button"
                  data-custom-multilikes-product-button
                  data-product-id="${escapeHtml(productData.id)}"
                  data-variant-id="${escapeHtml(variant.id)}"
                  aria-label="お気に入り">
            ${heartSvg}
          </button>
        </div>
      </li>`;
  }).join('');

  const modal = document.createElement('div');
  modal.id = modalId;
  modal.className = 'modal modal--square modal--wishlist-variants';
  modal.dataset.wishlistVariantsModal = '';
  modal.dataset.productId = productData.id;
  modal.innerHTML = `
    <div class="modal__inner">
      <div class="modal__centered">
        <div class="modal__centered-content">
          <h3 class="c-wishlist-variants-modal__title">${escapeHtml(productTitle)}</h3>
          <ul class="c-wishlist-variants-modal__list">${itemsHtml}</ul>
        </div>
        <button type="button" class="modal__close js-modal-close text-link" aria-label="閉じる">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64">
            <path d="M19 17.61l27.12 27.13m0-27.12L19 44.74"/>
          </svg>
        </button>
      </div>
    </div>`;
  return modal;
}

// ページのリロード時にページ上のボタンを初期化
document.addEventListener('DOMContentLoaded', () => {
  CustomProductWishlistButton.initAllButtons();
  CustomProductBrandWishlistButton.initAllButtons();
  initCustomProductWishlistGridTriggers();
});

// グローバル関数として公開
window.initCustomProductWishlist = function() {
  CustomProductWishlistButton.initAllButtons();
  CustomProductBrandWishlistButton.initAllButtons();
  initCustomProductWishlistGridTriggers();
};

document.addEventListener('shopify:section:load', () => {
  window.initCustomProductWishlist();
});
